import { useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { TelegramIcon } from "../../../assets/img/TelegramIcon";
import { TwitterIcon } from "../../../assets/img/TwitterIcon";
import { UploadIcon } from "../../../assets/img/UploadIcon";
import {
  CloseButton,
  CreateCollectionButton,
  CreateCollectionImg,
  CreateCollectionImgText,
  CreateCollectionImgWrapper,
  CreateCollectionMain,
  CreateCollectionWrapper,
  FileLabel,
  Icon,
} from "../../CreateCollection/CreateCollection.styled";
import { toggleEditProfileModal } from "../../../store/app/appSlice";
import { CreateNftSection } from "../../CreateNft/CreateNft.styled";

export const EditProfile = ({ toggleModal }) => {
  const [name, setName] = useState("");
  const [descriprion, setDescription] = useState("");
  const [royalties, setRoyalties] = useState("");
  const [twitter, setTwitter] = useState("");
  const [telegram, setTelegram] = useState("");
  const [banner, setBanner] = useState(null);
  const [bannerUrl, setBannerUrl] = useState(null);
  const [avatar, setAvatar] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null);
  const hiddenFileInput = useRef(null);
  const dispatch = useDispatch();

  const handleBannerChange = async (e) => {
    const uploadFile = Array.from(e.target.files);
    // exit if file is not of specified image type:
    if (
      !(
        uploadFile[0]?.type === "image/png" ||
        uploadFile[0]?.type === "image/jpeg" ||
        uploadFile[0]?.type === "image/jpg" ||
        uploadFile[0]?.type === "image/gif" ||
        uploadFile[0]?.type === "image/svg+xml" ||
        uploadFile[0]?.type === "video/mp4"
      )
    )
      if (uploadFile[0].size > 100000000) {
        // if file size is larger than 64mb or 64000000 bytes return error
        alert("File must be smaller than 100mb");
        return;
      }
    let url = URL.createObjectURL(uploadFile[0]);
    setBannerUrl(url);
    setBanner(uploadFile[0]);
  };

  const handleAvatarChange = async (e) => {
    const uploadFile = Array.from(e.target.files);
    // exit if file is not of specified image type:
    if (
      !(
        uploadFile[0]?.type === "image/png" ||
        uploadFile[0]?.type === "image/jpeg" ||
        uploadFile[0]?.type === "image/jpg" ||
        uploadFile[0]?.type === "image/gif" ||
        uploadFile[0]?.type === "image/svg+xml" ||
        uploadFile[0]?.type === "video/mp4"
      )
    )
      if (uploadFile[0].size > 100000000) {
        // if file size is larger than 64mb or 64000000 bytes return error
        alert("File must be smaller than 100mb");
        return;
      }
    let url = URL.createObjectURL(uploadFile[0]);
    setAvatarUrl(url);
    setAvatar(uploadFile[0]);
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  return (
    <CreateCollectionWrapper>
      <CreateCollectionMain>
        <CloseButton onClick={() => dispatch(toggleEditProfileModal())}>&#9587;</CloseButton>
        <h2>Edit Profile</h2>
        <CreateNftSection>
          <h5>Profile Image</h5>
          <CreateCollectionImgWrapper>
            <CreateCollectionImg>{avatarUrl && <img src={avatarUrl} alt='file image' />}</CreateCollectionImg>
            <CreateCollectionImgText>
              <h5>Upload a file</h5>
              <h6>
                File types supported: JPG and PNG. <br /> Max. size: 100MB
              </h6>
              <button onClick={handleClick}>{UploadIcon()}Replace</button>
              <input onChange={(e) => handleAvatarChange(e)} type='file' style={{ display: "none" }} ref={hiddenFileInput} />
            </CreateCollectionImgText>
          </CreateCollectionImgWrapper>
        </CreateNftSection>
        <CreateNftSection>
          <h5>Profile Banner</h5>
          <FileLabel>
            <input type='file' onChange={(e) => handleBannerChange(e)} />
            {bannerUrl ? (
              <img style={{ objectFit: "contain", maxHeight: "100%", maxWidth: "100%" }} src={bannerUrl} alt='file image' />
            ) : (
              <>
                <button>{UploadIcon()}Upload</button>
                Optimal dimensions: 2500×650
              </>
            )}
          </FileLabel>
        </CreateNftSection>
        <CreateNftSection>
          <h5>
            Name <span>{name.length}/60</span>
          </h5>
          <label>
            <input value={name} onChange={(e) => setName(e.target.value)} />
          </label>
        </CreateNftSection>
        <CreateNftSection>
          <h5>
            Description <span>{descriprion.length}/700</span>
          </h5>
          <label>
            <textarea onChange={(e) => setDescription(e.target.value)} rows={5}>
              {descriprion}
            </textarea>
          </label>
        </CreateNftSection>
        <CreateNftSection>
          <h5>Links</h5>
          <label>
            <input placeholder='twitter.com/' value={twitter} onChange={(e) => setTwitter(e.target.value)} style={{ paddingLeft: "50px" }} />
            <Icon> {TwitterIcon()}</Icon>
          </label>

          <label style={{ marginTop: "15px" }}>
            <input placeholder='t.me/' value={telegram} onChange={(e) => setTelegram(e.target.value)} style={{ paddingLeft: "50px" }} />
            <Icon> {TelegramIcon()}</Icon>
          </label>
        </CreateNftSection>
        <CreateCollectionButton>Save</CreateCollectionButton>
      </CreateCollectionMain>
    </CreateCollectionWrapper>
  );
};
